/**
 * ============================================================
 *  SMOOTH SCROLL PREMIUM — Shopify
 *  Défilement fluide façon "application native" sur desktop
 *  Fonctionne sur tous les navigateurs modernes.
 *  Sur mobile, le scroll natif est conservé (déjà très fluide).
 * ============================================================
 */

(function () {
  'use strict';

  // ── CONFIG ─────────────────────────────────────────────────
  const CONFIG = {
    ease: 0.085,        // Vitesse de lissage : 0.05 = très lent, 0.15 = rapide
    multiplier: 1.0,    // Sensibilité de la molette (1 = normal)
    touchMultiplier: 2, // Sensibilité tactile
  };
  // ───────────────────────────────────────────────────────────

  // Ne pas activer sur mobile (le scroll natif est déjà fluide)
  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  if (isMobile) return;

  // Ne pas activer si l'utilisateur préfère moins de mouvements (accessibilité)
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── VARIABLES D'ÉTAT ────────────────────────────────────── */
  let current = 0;   // position actuelle (px)
  let target = 0;    // position cible (px)
  let rafId = null;
  let isRunning = false;

  /* ── INITIALISATION ─────────────────────────────────────── */
  function init() {
    // Fixer le body en place — le vrai défilement se fait par CSS transform
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = '0';
    document.body.style.left = '0';

    // Créer un conteneur scrollable virtuel
    const scrollEl = document.createElement('div');
    scrollEl.id = '__smooth_scroll_container__';
    scrollEl.style.cssText = `
      position: fixed;
      top: 0; left: 0;
      width: 100%;
      will-change: transform;
    `;

    // Déplacer tout le contenu du body dans ce conteneur
    while (document.body.firstChild) {
      scrollEl.appendChild(document.body.firstChild);
    }
    document.body.appendChild(scrollEl);

    // Créer un espaceur pour que la page ait la bonne hauteur scrollable
    const spacer = document.createElement('div');
    spacer.id = '__smooth_scroll_spacer__';
    document.body.appendChild(spacer);

    // Écouter la molette
    window.addEventListener('wheel', onWheel, { passive: false });

    // Écouter les clics sur les ancres (#section) pour un scroll fluide vers elles
    document.addEventListener('click', onAnchorClick, true);

    // Démarrer la boucle d'animation
    updateSpacer(scrollEl, spacer);
    startLoop(scrollEl);

    // Recalculer quand la fenêtre change de taille
    window.addEventListener('resize', () => updateSpacer(scrollEl, spacer));

    // Recalculer régulièrement (au cas où le contenu change dynamiquement)
    setInterval(() => updateSpacer(scrollEl, spacer), 1000);
  }

  /* ── MISE À JOUR DE LA HAUTEUR DE L'ESPACEUR ────────────── */
  function updateSpacer(scrollEl, spacer) {
    spacer.style.height = scrollEl.scrollHeight + 'px';
  }

  /* ── GESTION DE LA MOLETTE ──────────────────────────────── */
  function onWheel(e) {
    e.preventDefault();
    target += e.deltaY * CONFIG.multiplier;
    clampTarget();
  }

  function clampTarget() {
    const maxScroll = document.body.scrollHeight - window.innerHeight;
    target = Math.max(0, Math.min(target, maxScroll));
  }

  /* ── GESTION DES ANCRES (#section) ─────────────────────── */
  function onAnchorClick(e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    const id = link.getAttribute('href').slice(1);
    if (!id) return;
    const el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    const rect = el.getBoundingClientRect();
    target += rect.top; // rect est relatif au viewport, on ajoute la position actuelle
    clampTarget();
  }

  /* ── BOUCLE D'ANIMATION ─────────────────────────────────── */
  function startLoop(scrollEl) {
    isRunning = true;

    function loop() {
      // Interpolation linéaire (lerp) : douceur du mouvement
      current += (target - current) * CONFIG.ease;

      // Appliquer le déplacement par transform (GPU-accéléré)
      scrollEl.style.transform = `translateY(${-current}px)`;

      // Synchroniser window.scrollY pour que les scripts Shopify (ex: sticky header) fonctionnent
      try {
        Object.defineProperty(window, 'scrollY', { value: current, configurable: true });
        Object.defineProperty(window, 'pageYOffset', { value: current, configurable: true });
      } catch (_) {}

      // Déclencher l'événement scroll pour les scripts tiers
      if (Math.abs(target - current) > 0.1) {
        window.dispatchEvent(new Event('scroll', { bubbles: false }));
      }

      rafId = requestAnimationFrame(loop);
    }

    loop();
  }

  /* ── DÉMARRAGE ──────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
